module.exports = __webpack_public_path__ + "static/img/快速生成应用@2x.76aa8653.png";